import axios from "axios";

interface Data {
  agentName: string;
  emailAddress: string;
}

export const resendLastBookingConfirmation = async ({
  agentName,
  emailAddress
}: Data) => {
  try {
    await axios.post(
      `${process.env.REACT_APP_API}/landing-page-proxy/api/confirmation`,
      { agentName, emailAddress }
    );
  } catch (error) {
    throw error;
  }
};
